import React, {useEffect} from 'react';
import cx from 'classnames';

import {withCommon} from '../../../../../components';
import {LicenseIcons, SocialIcons} from '../../../../layout-components';
import {resolveLocalizedString} from '../../../../../common/utils';

import config from "../../../../../static/themes/config";

/**
 * @desc Represents the markup for License Part of Footer of the Content
 *
 * @author A.Huskova
 */

const LLFooterLicense = withCommon({
    store: ({store}) => ({
        socialIcons: store.site.socialIcons.icons,
        modifiedConfig: store.modifiedConfig,
        language: store.user.language,
    }),
})(({
        modifiedConfig,
        socialIcons,
        customClasses,
        language,
    }) => {
    const licenseText = resolveLocalizedString(config.licenseText, language);

    useEffect(() => {
        if (config.scripts?.footerLcQuality) {
            const range = document.createRange();
            document.head.appendChild(
                range.createContextualFragment(
                    config.scripts.footerLcQuality
                )
            );
        }
    }, []);

    return (
        <div className={cx(
            'footer-menu__section footer-menu__section--info',
            customClasses
        )}
        >
            {modifiedConfig.footerLicenceIcons?.length ?
                <div className="footer-license">
                    <LicenseIcons
                        licenseIcons={modifiedConfig.footerLicenceIcons}
                        classSuffix="--desktop"
                    />
                </div>
                : null
            }
            {
                /**** ~~ Render Social Icons Section ****/
                !!socialIcons?.length && (
                    <div className="footer-menu__social-icons-container">
                        <SocialIcons/>
                    </div>
                )
            }
            {licenseText ? <div className="footer-license-message">{licenseText}</div> : null}
            {config.scripts?.footerLcQuality ? <div className="footer-lcquality" id="lcqualitybadge"/> : null}
        </div>
    )
});

export default LLFooterLicense;